import React, { useState, useEffect } from 'react';
import { PRESET_LABELS, presetRange, rangeText, daysBetween } from '../dateRange';

// Sticky date-range bar that stays under the top bar while the page scrolls.
// value: { preset, start, end } (start/end null for 'all'); onChange gets the same shape.
export default function DateRangeBar({ value, onChange, presets = [7, 28, 90, 'this_month', 'last_month'], note, children }) {
  const [custom, setCustom] = useState(value.preset === 'custom');
  const [from, setFrom] = useState(value.start || '');
  const [to, setTo] = useState(value.end || '');

  useEffect(() => { setFrom(value.start || ''); setTo(value.end || ''); }, [value.start, value.end]);

  const valid = from && to && from <= to;

  return (
    <div className="date-range-bar">
      <div className="date-range-row">
        {presets.map(p => (
          <button key={p} className={'filter-chip' + (!custom && String(value.preset) === String(p) ? ' active' : '')}
            onClick={() => { setCustom(false); onChange(presetRange(String(p))); }}>
            {PRESET_LABELS[p] || p}
          </button>
        ))}
        <button className={'filter-chip' + (custom ? ' active' : '')} onClick={() => setCustom(true)}>
          טווח מותאם
        </button>
        {custom && (
          <span className="date-range-custom">
            <input type="date" value={from} max={to || undefined} onChange={e => setFrom(e.target.value)} />
            <span style={{ color: 'var(--text-muted)' }}>עד</span>
            <input type="date" value={to} min={from || undefined} onChange={e => setTo(e.target.value)} />
            <button className="btn-sm primary" disabled={!valid}
              onClick={() => onChange({ preset: 'custom', start: from, end: to })}>החל</button>
          </span>
        )}
        <div className="filter-spacer" />
        {children}
        <span className="date-range-label">
          {value.start && value.end
            ? <>📅 {rangeText(value.start, value.end)} <span style={{ color: 'var(--text-muted)' }}>({daysBetween(value.start, value.end)} ימים)</span></>
            : '📅 כל הנתונים שנאספו'}
        </span>
      </div>
      {note && <div className="date-range-note">{note}</div>}
    </div>
  );
}
